module.exports = __webpack_public_path__ + "static/img/物理師資介紹.f4af9cc7.png";